// commonCoonfig.js
import { ElMessage } from 'element-plus';

// 通用请求配置
const commonRequestConfig = {
  // 设置API基础域名（已写死为正式域名）
  baseURL: 'https://test.zhult.com/',

  // 指定请求超时的毫秒数
  timeout: 3000,
  // 表示支持跨域请求携带Cookie，默认是false，表示不携带Cookie
  // 同时需要后台配合，返回需要有以下字段，
  // 如果该字段设置为true，但是后台没有返回以下两个字段的话浏览器是会报错的
  // Access-Control-Allow-Credentials: true
  // Access-Control-Allow-Origin: 当前页面的域名
  withCredentials: false,
};

// 通用的请求拦截器
const commonRequestInterceptors = [
  {
    onFulfilled: (config) => {
      /**
       * 在这里一般会携带前台的参数发送给后台，比如下面这段代码：
       * const token = getToken()
       * if (token) {
       *  config.headers.token = token
       * }
       */
      // 从localStorage获取token并添加到请求头
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        try {
          const userData = JSON.parse(userInfo)
          if (userData.token) {
            config.headers.Authorization = `bearer ${userData.token}`
          }
        } catch (error) {
          console.error('解析用户信息失败:', error)
        }
      }
      return config;
    },
    onRejected: (error) => {
      const errorMsg = error?.message || 'Request Error';
      ElMessage({
        message: errorMsg,
        type: 'error',
      });
      return Promise.reject(error);
    },
  },
];

// 通用的响应拦截器
const commonResponseInterceptors = [
  {
    onFulfilled: (response) => {
      // 这里我们将后台返回的数据解构出来返回，方便后续获取
      const { data } = response;
      return data;
    },
    onRejected: (error) => {
      const { response } = error;
      // 处理 HTTP 网络错误
      let message = '';
      // HTTP 状态码
      const status = response?.status;
      switch (status) {
        case 401:
          message = 'token 失效，请重新登录';
          // 这里可以触发退出的 action
          break;
        case 403:
          message = '拒绝访问';
          break;
        case 404:
          message = '请求地址错误';
          break;
        case 500:
          message = '服务器故障';
          break;
        default:
          message = '网络连接故障';
      }

      ElMessage({
        message: message,
        type: 'error',
      });
      return Promise.reject(error);
    },
  },
];

export {
  commonRequestConfig,
  commonRequestInterceptors,
  commonResponseInterceptors,
};
